<div class="program-header">
  <div class="program-header__row">
    @if (!hideTitle) {
      <h1 class="program-header__title headline5">{{ displayTitle }}</h1>
    }

    <div class="program-header__actions">
      <ptl-button
        type="smoke"
        [matMenuTriggerFor]="languageMenu"
        *ngIf="availableLanguages?.length > 1"
        [icon]="LucideLanguages"
        [ariaLabel]="'translations.global.ariaLabels.icons.language' | transloco"
      ></ptl-button>

      <mat-menu #languageMenu="matMenu">
        <button
          mat-menu-item
          *ngFor="let language of availableLanguages"
          class="language-menu-item"
          [class.is_active]="language.code === selectedLanguageCode"
          [attr.aria-label]="'translations.global.ariaLabels.icons.changeLanguageTo' | transloco: { lang: language.name }"
          (click)="languageSelect(language.code)"
          [value]="language.code"
        >
          {{ language.code.toUpperCase() }}
        </button>
      </mat-menu>

      @if (canEdit) {
        <ptl-button
          class="edit-btn"
          type="smoke"
          [icon]="LucidePencil"
          [text]="'translations.programs.edit.editContent' | transloco"
          (clicked)="editClicked.emit()"
        ></ptl-button>
      }

      <ptl-button
        type="smoke"
        [icon]="LucideShare2"
        [ariaLabel]="'translations.global.ariaLabels.icons.share' | transloco"
        (clicked)="shareProgram()"
      ></ptl-button>

      <ptl-button
        type="smoke"
        *ngIf="!isCard"
        [icon]="$any(program)?.favorite ? LucideBookmark : LucideBookmarkCheck"
        [ariaLabel]="'translations.global.ariaLabels.icons.save' | transloco"
        (clicked)="saveItem()"
      ></ptl-button>

      <ptl-button
        type="smoke"
        [icon]="LucideDownload"
        [ariaLabel]="'translations.global.ariaLabels.icons.download' | transloco"
        (clicked)="downloadReport()"
      >
        <mat-spinner *ngIf="downloadInProgress" [diameter]="16"></mat-spinner>
      </ptl-button>
    </div>
  </div>

  <div class="card-view__report-container" *ngIf="report">
    <ptl-playlist-report #playlistReportComponent [report]="report" (pdfDownloaded)="onReportDownloaded()" (pdfError)="onReportPdfError()">
    </ptl-playlist-report>
  </div>
</div>
